import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from './../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CacheControlInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization headers only for non-S3 API calls
    if (request.url.startsWith(environment.apiBaseUrlAsset) &&
          request.method === 'PUT') {
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache, no-store'
          }
      });
    }

    return next.handle(request);
  }
}
